import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import { AuthProvider } from './context/AuthContext';
import { VendorProvider } from './context/VendorContext';
import { ServiceProvider } from './context/ServiceContext';

const STALE_CHUNK_RELOAD_KEY = 'advika_vendor_stale_chunk_reload';
const isStaleChunkError = (message = '') => (
  /Failed to fetch dynamically imported module/i.test(message) ||
  /Importing a module script failed/i.test(message) ||
  /Loading chunk \d+ failed/i.test(message)
);

const reloadForFreshBuild = () => {
  if (typeof window === 'undefined') return;
  const alreadyReloaded = window.sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY);
  if (alreadyReloaded === '1') return;
  window.sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, '1');
  window.location.reload();
};

window.addEventListener('error', (event) => {
  const message = event?.message || event?.error?.message || '';
  if (isStaleChunkError(message)) {
    reloadForFreshBuild();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason;
  const message = reason?.message || String(reason || '');
  if (isStaleChunkError(message)) {
    reloadForFreshBuild();
  }
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <AuthProvider>
    <ServiceProvider>
      <VendorProvider>
        <App />
      </VendorProvider>
    </ServiceProvider>
  </AuthProvider>
);;
